export default "__VITE_PUBLIC_ASSET__551b8491__"